import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useDeletePayout(campaignInfluencerId: string) {
  const {
    mutate: deletePayout,
    isLoading: isDeleting,
    isSuccess: isDeleted,
    variables,
  } = useMutation<{ vendorPaymentId: string }>({
    mutationFn: async ({ vendorPaymentId }) => {
      return await CampaignService.deletePayout(
        campaignInfluencerId,
        vendorPaymentId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    deletePayout,
    isDeleting,
    isDeleted,
    variables,
  };
}
